import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
const pointsHandlerMap = {
    targetUnderPoints: (currentPoints, pointsLine) => getStatus(currentPoints, pointsLine, ["WINNING", "EQUAL", "LOSING"]),
    targetOverPoints: (currentPoints, pointsLine) => getStatus(pointsLine, currentPoints, ["WINNING", "EQUAL", "TEMPLOSING"])
};
const getStatus = (currentPoints, pointsLine, statuses) => {
    const [winnning, equal, loosing] = statuses;
    if (currentPoints < pointsLine) {
        return winnning;
    }
    else if (currentPoints === pointsLine) {
        return equal;
    }
    else {
        return loosing;
    }
};
export const parsePointsMetaData = (pointsMetadata, isSelectionOpened) => {
    const pointsLine = getTruthyValue(pointsMetadata === null || pointsMetadata === void 0 ? void 0 : pointsMetadata.targetUnderPoints, pointsMetadata === null || pointsMetadata === void 0 ? void 0 : pointsMetadata.targetOverPoints);
    if (isSelectionOpened && pointsLine && pointsMetadata && pointsMetadata.currentTotalPoints !== undefined) {
        const key = pointsMetadata.targetUnderPoints !== undefined ? "targetUnderPoints" : "targetOverPoints";
        const currentPoints = pointsMetadata.currentTotalPoints;
        const status = pointsHandlerMap[key](currentPoints, pointsLine);
        return {
            pointsLine,
            currentPoints,
            status
        };
    }
    return undefined;
};
//# sourceMappingURL=parsePointsMetadata.js.map